var y = (s) => {
  throw TypeError(s);
};
var u = (s, e, t) => e.has(s) || y("Cannot " + t);
var m = (s, e, t) => (u(s, e, "read from private field"), t ? t.call(s) : e.get(s)), E = (s, e, t) => e.has(s) ? y("Cannot add the same private member more than once") : e instanceof WeakSet ? e.add(s) : e.set(s, t), p = (s, e, t, i) => (u(s, e, "write to private field"), i ? i.call(s, t) : e.set(s, t), t), a = (s, e, t) => (u(s, e, "access private method"), t);
const A = (s) => {
  const e = s.querySelectorAll(
    'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
  );
  return e[e.length - 1];
}, b = class b extends HTMLElement {
  constructor() {
    super(), this.activeElement = void 0, this.menus = this.querySelectorAll("[menu]"), this.menuTriggers = this.querySelectorAll("[menu-trigger]"), this._handlePointerEnter = this._handlePointerEnter.bind(this), this._handlePointerOut = this._handlePointerOut.bind(this), this._handleMenuPointerEnter = this._handleMenuPointerEnter.bind(this), this._handleMenuPointerOut = this._handleMenuPointerOut.bind(this), this._handleButtonKeyDown = this._handleButtonKeyDown.bind(this), this._handleMenuCloseKeyDown = this._handleMenuCloseKeyDown.bind(this), this._handleMenuFocusOut = this._handleMenuFocusOut.bind(this), this.startExitTimer = this.startExitTimer.bind(this), this.stopExitTimer = this.stopExitTimer.bind(this), this.activateMenuWithControl = this.activateMenuWithControl.bind(this);
  }
  get ctor() {
    return this.constructor;
  }
  connectedCallback() {
    Array.from(this.menuTriggers).forEach((e) => {
      e.addEventListener("pointerover", this._handlePointerEnter), e.addEventListener("pointerout", this._handlePointerOut), e.addEventListener("keydown", this._handleButtonKeyDown);
    }), Array.from(this.menus).forEach((e) => {
      var t;
      e.addEventListener("pointerover", this._handleMenuPointerEnter), e.addEventListener("pointerout", this._handleMenuPointerOut), e.addEventListener("keydown", this._handleMenuCloseKeyDown), (t = A(e)) == null || t.addEventListener(
        "keydown",
        this._handleMenuFocusOut
      );
    });
  }
  _handleActivateButton(e) {
    e.getAttribute("aria-controls") ? (this.stopExitTimer(), this.setActiveElement(e)) : this.setActiveElement(void 0);
  }
  _handleButtonKeyDown(e) {
    const t = e.currentTarget;
    if (e.key === "Enter" || e.key === " ")
      if (e.preventDefault(), this.activeElement === t)
        if (t.tagName.toLowerCase() === "a" && t.hasAttribute("href")) {
          const i = t.getAttribute("href");
          i && (window.location.href = i);
        } else
          t.click();
      else
        this._handleActivateButton(t);
    else e.key === "Escape" && (e.preventDefault(), this.setActiveElement(void 0), t.focus());
  }
  _handleMenuCloseKeyDown(e) {
    if (e.key === "Escape") {
      e.preventDefault(), this.setActiveElement(void 0);
      const t = Array.from(this.menuTriggers).find(
        (i) => i.getAttribute("aria-expanded") === "true"
      );
      t == null || t.focus();
    }
  }
  _handleMenuFocusOut(e) {
    e.key === "Tab" && !e.shiftKey && this.startExitTimer();
  }
  _handlePointerEnter(e) {
    const t = e.currentTarget;
    this._handleActivateButton(t);
  }
  _handlePointerOut(e) {
    const t = e.currentTarget;
    this.activeElement === t && this.startExitTimer();
  }
  _handleMenuPointerEnter() {
    this.stopExitTimer();
  }
  _handleMenuPointerOut() {
    this.startExitTimer();
  }
  startExitTimer() {
    this.exitTimer = window.setTimeout(() => {
      this.setActiveElement(void 0);
    }, this.ctor.EXIT_TIMEOUT);
  }
  stopExitTimer() {
    this.exitTimer && window.clearTimeout(this.exitTimer);
  }
  setActiveElement(e) {
    if (this.activeElement !== e)
      if (this.activeElement = e, this.activateMenuWithControl(this.activeElement), this._handleMenuDrawerARIATags(), this.dataset.state = this.activeElement ? "active" : "inactive", this.activeElement) {
        const t = this.activeElement.getAttribute("aria-controls"), i = this.querySelector(`#${t}`);
        if (i) {
          const n = i.getBoundingClientRect().height;
          this.style.setProperty("--mega-menu-height", `${n}px`);
        } else
          this.style.setProperty("--mega-menu-height", "10px");
      } else
        this.style.setProperty("--mega-menu-height", "0px");
  }
  activateMenuWithControl(e) {
    for (const t of Array.from(this.menuTriggers))
      t.getAttribute("aria-controls") && t === e ? t.setAttribute("aria-expanded", "true") : t.setAttribute("aria-expanded", "false");
  }
  _handleMenuDrawerARIATags() {
    for (const e of Array.from(this.menus)) {
      if (!this.activeElement) {
        e.setAttribute("aria-hidden", "true");
        continue;
      }
      const t = this.activeElement.getAttribute("aria-controls");
      e.id === t ? e.setAttribute("aria-hidden", "false") : e.setAttribute("aria-hidden", "true");
    }
  }
};
b.EXIT_TIMEOUT = 100;
let f = b;
window.customElements.get("mega-menu") || window.customElements.define("mega-menu", f);
var h, l, c;
const v = class v extends HTMLElement {
  constructor() {
    super();
    E(this, l);
    E(this, h);
    this.lastScrollY = window.scrollY, this.lastPageHeight = document.documentElement.scrollHeight, p(this, h, new ResizeObserver(() => a(this, l, c).call(this))), this.hasStickyEnabled = !0, this.hasStickyEnabled = this.getAttribute("is-sticky") === "true";
  }
  connectedCallback() {
    a(this, l, c).call(this), m(this, h).observe(this), this.setUpFoldObserver(), this.hasStickyEnabled && (this.timeInterval = setInterval(() => {
      this.setNewScrollValue(window.scrollY);
    }, 150));
  }
  setUpFoldObserver() {
    const t = {
      root: null,
      threshold: 0.1
    }, i = new IntersectionObserver((n) => {
      n.forEach((o) => {
        o.isIntersecting || (document.body.setAttribute("data-below-fold", "true"), this.dispatchEvent(
          new CustomEvent("header:below-fold", {
            bubbles: !0
          })
        ), i.disconnect());
      });
    }, t);
    i.observe(this);
  }
  get scrollDirection() {
    return parseInt(this.getAttribute("data-scroll-direction") || "0", 10);
  }
  attributeChangedCallback(t, i) {
    t === "data-scroll-direction" && (parseInt(i, 10) === 0 && this.scrollDirection === 1 ? this.classList.add("opacity-0") : this.classList.remove("opacity-0"), a(this, l, c).call(this));
  }
  get isSticky() {
    return this.scrollDirection === -1 && this.hasStickyEnabled;
  }
  disconnectedCallback() {
    m(this, h).disconnect();
  }
  setScrollDirection(t) {
    this.setAttribute("data-scroll-direction", t.toString());
  }
  setNewScrollValue(t) {
    if (this.lastPageHeight !== document.documentElement.scrollHeight) {
      this.lastScrollY = t, this.lastPageHeight = document.documentElement.scrollHeight;
      return;
    }
    const i = this.clientHeight + 600, n = this.clientHeight + 800;
    if (this.scrollDirection === 0 && t <= n) {
      this.lastScrollY = t;
      return;
    }
    if (this.scrollDirection === -1 && t <= i) {
      this.setScrollDirection(1), setTimeout(() => {
        this.setScrollDirection(0);
      }, 250), this.lastScrollY = t;
      return;
    }
    if (t <= i) {
      this.setScrollDirection(0), this.lastScrollY = t;
      return;
    }
    Math.abs(t - this.lastScrollY) < 5 || (t >= this.lastScrollY ? this.setScrollDirection(1) : this.setScrollDirection(-1), this.lastScrollY = t);
  }
};
h = new WeakMap(), l = new WeakSet(), c = function() {
  const t = this.clientHeight, i = this.querySelector(
    ".shopify-section-main-header .header-internal-wrapper"
  ), n = this.querySelector(
    "[data-header-col-1]"
  );
  if (document.documentElement.style.setProperty(
    "--header-height-actual",
    `${t}px`
  ), this.isSticky ? i && document.documentElement.style.setProperty(
    "--header-height",
    `${i.clientHeight}px`
  ) : document.documentElement.style.setProperty("--header-height", "0px"), n) {
    const o = n.querySelectorAll("div[data-logo]");
    n.clientWidth > 271 ? o.forEach((r, d) => {
      d < 2 ? r.classList.remove("hidden") : r.classList.add("hidden");
    }) : n.clientWidth > 149 ? o.forEach((r, d) => {
      d < 1 ? r.classList.remove("hidden") : r.classList.add("hidden");
    }) : o.forEach((r) => {
      r.classList.add("hidden");
    });
  }
}, v.observedAttributes = ["data-scroll-direction", "is-sticky"];
let g = v;
window.customElements.define("main-header", g);
export {
  g as MainHeader
};
